import React, { useEffect, useState } from "react";
import { useReviewImageRefunds } from "@/hooks/use-usage";

type Review = { actionId: number; status: 'not_reviewed' | 'pending' | 'refunded' };
/** Each control targets the original image action, even inside a grouped chat request. */
export function ImageBillingReview({ reviews = [] }: { reviews?: Review[] }) {
  const mutation = useReviewImageRefunds();
  const [queued, setQueued] = useState<number[]>([]);
  useEffect(() => {
    // Once the server has acknowledged pending/completed, server state owns the
    // control again; a later needs-review outcome can be explicitly retried.
    setQueued(ids => {
      const remaining = ids.filter(id => reviews.some(review => review.actionId === id && review.status === 'not_reviewed'));
      return remaining.length === ids.length ? ids : remaining;
    });
  }, [reviews]);
  return <div className="text-xs text-neutral-500">
    {reviews.map(review => {
      const pending = review.status === 'pending' || (review.status !== 'refunded' && queued.includes(review.actionId));
      if (review.status === 'refunded') return <div key={review.actionId}>Confirmed image billing refund applied.</div>;
      return <div key={review.actionId} className="mt-1">
        <button type="button" className="text-blue-700 underline disabled:text-neutral-500 disabled:no-underline" disabled={pending || mutation.isPending}
          onClick={() => mutation.mutate(review.actionId, { onSuccess: () => setQueued(ids => [...ids, review.actionId]) })}>
          {pending ? 'Image billing review pending' : 'Review image billing'}
        </button>
        {pending && <div role="status">Checking the supplier’s billing record. Credits are returned only after confirmation.</div>}
      </div>;
    })}
    {mutation.isError && <div role="alert">Billing review could not be queued. Please try again later.</div>}
  </div>;
}
